import actions from './actions';

export default {
  getSections: actions.getSections,
};
